module.exports = __webpack_public_path__ + "img/bg.efc33fef.jpg";